import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getPermissionsSaga() {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.Permissions.filters);

        let queryString = ``;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/permissions?${queryString}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_PERMISSIONS_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_PERMISSIONS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_PERMISSIONS_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

/* function* createPermissionSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData } = payload;
        formData.azure_account = true;

        const { data } = yield API.post("/permissions", formData);

        if (data.success) {
            yield put({ type: actionTypes.CREATE_PERMISSION_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PERMISSIONS, params: {} });
        } else {
            console.error("Error occurred while adding permissions:", data);
            yield put({ type: actionTypes.CREATE_PERMISSION_FAILURE, payload: data });
        }

    } catch (error) {
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_PERMISSION_FAILURE, payload: data || { message: "Internal server error" } });
    }
}; */

function* updatePermissionSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData } = payload;
        const id = formData.id;
        delete formData.id;

        const { data } = yield API.put(`/permissions/${id}`, formData);

        if (data.success) {
            yield put({ type: actionTypes.UPDATE_PERMISSION_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PERMISSIONS, params: {} });
        } else {
            toast.error(data?.message || "Could not save updated data.");
            yield put({ type: actionTypes.UPDATE_PERMISSION_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_PERMISSION_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

/* function* deletePermissionSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/permissions/${Id}`);

        if (data.success) {
            yield put({ type: actionTypes.DELETE_PERMISSION_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PERMISSIONS, params: {} });
        } else {
            console.error("Error occurred while adding permissions:", data);
            yield put({ type: actionTypes.DELETE_PERMISSION_FAILURE, payload: data });
        }

    } catch (error) {
        const data = error?.response?.data;
        yield put({ type: actionTypes.DELETE_PERMISSION_FAILURE, payload: data || { message: "Internal server error" } });
    }
}; */


function* PermissionsSaga() {
  yield all([
    takeLatest(actionTypes.GET_PERMISSIONS, getPermissionsSaga),
    // takeLatest(actionTypes.CREATE_PERMISSION, createPermissionSaga),
    takeLatest(actionTypes.UPDATE_PERMISSION, updatePermissionSaga),
    // takeLatest(actionTypes.DELETE_PERMISSION, deletePermissionSaga),
  ]);
}

export default PermissionsSaga;
